module.exports = __webpack_public_path__ + "static/media/sample-club.e549dc20.png";